import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Applicants } from '../applicants/Applicants';
import { UrlSignature } from '../common/apiEndpoint';

@Injectable({
  providedIn: 'root'
})
export class RegisteredApplicantsService {
  constructor( private httpclient:HttpClient, private urlsignature: UrlSignature) { }


  getRegisteredApplicantList(
    year: string,
    programmeId: string,
    programmeTypeId: string,
  ): Observable<Applicants[]> {
    const url =
      this.urlsignature.applicantTypeListregUrl +
      year +
      '/' +
      programmeId +
      '/' +
      programmeTypeId;
    return this.httpclient
      .get(url)
      .pipe(map((response) => response as Applicants[]));
  }

}
